/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountcreated1Inputs */

const en_accountcreated1 = /** @type {(inputs: Accountcreated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account created`)
};

const de_accountcreated1 = /** @type {(inputs: Accountcreated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto erstellt`)
};

/**
* | output |
* | --- |
* | "Account created" |
*
* @param {Accountcreated1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const accountcreated1 = /** @type {((inputs?: Accountcreated1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountcreated1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accountcreated1(inputs)
	return de_accountcreated1(inputs)
});
export { accountcreated1 as "accountCreated" }